import { useSearchParams } from "react-router-dom";
// import { AdvizerVideo } from "../AdvizerVideo";
// import { ErrorBoundary } from "../ErrorBoundary";
// import { IAdvizerVideo } from "@/models/AdvizerVideo";
// import { useEffect } from "react";

export function EmbeddedVideo() {
  const [searchParams] = useSearchParams();

  const videoId =
    searchParams.get("videoId") || "83b3c9ae-7b71-4f5c-a276-09e398232fef";

  // const [video, setVideo] = useState<IAdvizerVideo | null>(null);

  // useEffect(() => {
  //   // const video = getVideoById(videoId);
  //   // setVideo(video);

  //   async function init() {}
  // }, []);

  console.log("Embed video", { videoId });

  return null;

  // return (
  //   <ErrorBoundary fallback={<div>Error</div>}>
  //     <AdvizerVideo videoId={videoId} />
  //   </ErrorBoundary>
  // );
}
